import React, { useState } from 'react';
import { MessageSquare, X, Bug, Lightbulb } from 'lucide-react';
import { db } from '../db';
import { toast } from '../utils/feedback';
import { useAuth } from '../context/AuthContext';

export const FeedbackModal = ({ onClose, currentProfile }) => {
  const [type, setType] = useState('bug');
  const [message, setMessage] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const { currentUser } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    setSubmitting(true);
    try {
      await db.addFeedback({
        profileId: currentProfile?.id || 'anonymous',
        profileName: currentProfile?.name || 'Anonyme',
        userEmail: currentUser?.email || 'Inconnu',
        type,
        message: message.trim()
      });

      await db.addNotification({
        targetProfileId: 'VX3fSmgFvr20XLYuzZv8',
        message: `Nouveau retour (${type}) de ${currentProfile?.name || 'Anonyme'}`,
        link: '/admin',
        type: 'feedback'
      });

      toast.success("Merci pour ton retour !");
      onClose();
    } catch (err) {
      toast.error("Erreur lors de l'envoi.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.8)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 10000 }}>
      <div className="card" style={{ width: '90%', maxWidth: '600px', animation: 'scaleIn 0.2s ease-out' }}>
        <div className="flex justify-between items-center mb-4">
          <h3 style={{ margin: 0 }}>Signaler un bug / Suggestion</h3>
          <button className="btn-icon" onClick={onClose}><X size={20} /></button>
        </div>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label className="form-label">Type de retour</label>
            <div style={{ display: 'flex', gap: '1rem', marginBottom: '1rem' }}>
              <button 
                type="button" 
                className={`btn ${type === 'bug' ? 'btn-primary' : 'btn-outline'}`} 
                style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
                onClick={() => setType('bug')}
              >
                <Bug size={18} /> Bug
              </button>
              <button 
                type="button" 
                className={`btn ${type === 'suggestion' ? 'btn-primary' : 'btn-outline'}`} 
                style={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '0.5rem' }}
                onClick={() => setType('suggestion')}
              >
                <Lightbulb size={18} /> Suggestion
              </button>
            </div>
          </div>
          <div className="form-group">
            <label className="form-label">Message</label>
            <textarea 
              className="form-control" 
              rows="4" 
              value={message} 
              onChange={e => setMessage(e.target.value)} 
              placeholder="Décris le problème ou ton idée..."
              required
            ></textarea>
          </div>
          <button type="submit" className="btn btn-primary" style={{ width: '100%', marginBottom: '1rem' }} disabled={submitting}>
            {submitting ? 'Envoi...' : 'Envoyer'}
          </button>
          <div style={{ textAlign: 'center', fontSize: '0.9rem', color: 'var(--text-secondary)' }}>
            Une préférence pour les mails ? <a href="mailto:contact@masse-terclass.com" style={{ color: 'var(--primary-color)', textDecoration: 'none' }}>contact@masse-terclass.com</a>
          </div>
        </form>
      </div>
    </div>
  );
};

export const FloatingFeedbackButton = ({ currentProfile }) => {
  const [showModal, setShowModal] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  if (isMobile) return null;

  return (
    <>
      <button 
        onClick={() => setShowModal(true)}
        style={{
          position: 'fixed',
          bottom: '20px',
          right: '20px',
          height: '50px',
          padding: '0 20px',
          borderRadius: '25px',
          backgroundColor: 'var(--primary-color)',
          color: 'white',
          border: 'none',
          boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
          display: 'flex',
          alignItems: 'center',
          gap: '10px',
          cursor: 'pointer',
          zIndex: 9900,
          transition: 'transform 0.2s ease, background-color 0.2s ease'
        }}
        title="Signaler un bug / Suggestion"
        onMouseOver={e => e.currentTarget.style.transform = 'scale(1.05)'}
        onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
      >
        <div style={{
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          border: '2px solid white',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontSize: '0.9rem',
          fontWeight: 'bold'
        }}>?</div>
        <span style={{ fontSize: '0.95rem', fontWeight: '500' }}>Signaler un bug / problème ?</span>
      </button>

      {showModal && <FeedbackModal currentProfile={currentProfile} onClose={() => setShowModal(false)} />}
    </>
  );
};
